import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import MessengerMessages from './MessengerMessages';
import Loading from '../../Loading';
import Typing from '../../feedbackdetail/Typing';
import { getChatStatus, ajaxNewChat, ajaxNewChatVC, setTimerInterval, ajaxTyping } from '../../redux/FeedbackRedux';


class MessengerSection extends React.Component {
    constructor(props) {
        super(props);
        const id = this.props.feedback_id;
        this.state = { value: '', initial_feedback: id, last_typing: Math.floor(Date.now() / 1000) };
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
    }
    handleChange(event) {
        this.setState(
            { value: event.target.value }
        );
        var now = Math.floor(Date.now() / 1000);
        if (this.state.sent_first == true) {
            if (now > (this.state.last_typing + 2)) {
                this.props.dispatch(ajaxTyping(this.props.feedback.feedback_id, true));
                this.setState(
                    { last_typing: now }
                );
            }
        } else {
            this.props.dispatch(ajaxTyping(this.props.feedback.feedback_id, true));
            this.setState(
                { last_typing: now, sent_first: true }
            );
        }
    }

    handleClick(event) {
        if (this.props.loading == false && this.state.value != '') {
            this.props.dispatch(ajaxTyping(this.props.feedback.feedback_id, false));
            this.props.dispatch(ajaxNewChatVC(this.state.value, this.props.feedback.feedback_id));
        }
        this.setState(
            { value: '' }
        );
    }

    handleClickMobile(event) {
        if (this.props.loading == false && this.state.value != '') {
            this.props.dispatch(ajaxNewChatVC(this.state.value, this.props.feedback.feedback_id));
        }
        this.setState(
            { value: '' }
        );
    }

    handlePreCanned(event) {
        event.preventDefault();
        var data = jQuery(event.target).attr('data-text');
        this.setState(
            { value: data }
        );
    }

    handleReview(event) {
        event.preventDefault();
        var data = jQuery(event.target).attr('data-text');
        this.setState(
            { value: data }
        );
    }

    handleReviewOnly(event) {
        event.preventDefault();
        if (!(this.props.feedback.is_include_contact && this.props.feedback.user.phone)) {
            warnNoChat(this.props.feedback.is_include_contact, this.props.dispatch);
            return;
        }
        var data = jQuery("#chat-textarea").val() + " " + jQuery(event.target).attr('data-text');
        console.log(data);
        data = data.replace(/\s+/g, ' ').trim();
        this.setState(
            { value: data },
            () => {
                jQuery("#chat-textarea").trigger("input");
            }
        );
    }



    handleEmojiClick(event) {
        // var v = this.state.value;
        // this.setState(
        //     {value: v + event.detail.unicode}
        // );
        // if(this.state.cleared != false) {
        //     this.setState({
        //         cleared: false,
        //       });
        // }
        // if(event.detail){
        //     jQuery('.emoji-dropdown.show, .emoji-dropdown .show').removeClass('show');
        // }
        return true;
    }

    componentDidUpdate() {
        if (this.state.initial_feedback != this.props.feedback_id) {
            if (this.state.value != "") {
                this.setState({
                    value: "",
                    initial_feedback: this.props.feedback_id,
                });
            }
        }
    }

    componentDidMount() {
        this.props.dispatch(setTimerInterval());
        // document.querySelector('emoji-picker').addEventListener('emoji-click', event => this.handleEmojiClick(event));
        // $('.emoji-dropdown .dropdown-menu *').click(function(e) {
        //     e.stopPropagation();
        // });
    }

    render() {
        const { chat_alert, chat_button_text } = getChatStatus(this.props.feedback);
        return (
            <div className="card-body chat border-topx">
                <div className="row">
                    {this.props.feedback.chats.length > 0 &&
                        <div className="col-md-12">
                            <div className="pb-4 pt-4 pl-2 pr-3 pl-sm-0 pr-sm-0 chat_widget" id="chat_widget">
                                <MessengerMessages />
                                <Typing />
                            </div>
                        </div>
                    }


                    <div className='col-sm-12 pl-3'>
                        <Loading location={'chat'} />
                    </div>
                    <div
                        className="text-right d-none d-sm-flex mt-2 justify-content-end align-items-center bg-white py-3 px-3 position-fixed"
                        style={{ bottom: 0, width: `calc(100% - ${$(".sidebar-v2").width() + 21}px)` }}
                    >
                        <div className="overflow-hidden w-100 mr-3">
                            <div className="input-group feedback-form-control mb-0">
                                <input onChange={this.handleChange.bind(this)} id="chat-textarea" value={this.state.value} className="input pl-3 form-control" placeholder={__('Type your message') + '...'} aria-label="Type your message..." />
                            </div>
                        </div>
                        {this.props.feedback.business.social_media && (this.props.feedback.business.social_media.iwanttoplay == 1) &&
                            <div className="dropdown">
                                <button className="btn btn-outline-secondary mr-2 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {__('Insert Rating Request')}
                                </button>

                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    {this.props.feedback.business.social_media && (this.props.feedback.business.social_media.iwanttoplay == 1) &&
                                        <button className="dropdown-item" data-text={this.props.feedback.business.social_media && this.props.feedback.business.social_media.iwanttoplay == 1 ? this.props.feedback.business.social_media.description + " https://ratethisbiz.com/" + this.props.feedback.short_id : null} onClick={this.handleReview.bind(this)} type="button">{__('Send Review Request - Issue')}</button>
                                    }
                                    {this.props.feedback.business.social_media && (this.props.feedback.business.social_media.iwanttoplay == 1) &&
                                        <button className="dropdown-item" data-text={this.props.feedback.business.social_media && this.props.feedback.business.social_media.iwanttoplay == 1 ? this.props.feedback.business.social_media.description_positive + " https://ratethisbiz.com/" + this.props.feedback.short_id : null} onClick={this.handleReview.bind(this)} type="button">{__('Send Review Request - Happy')}</button>
                                    }
                                    {this.props.feedback.business.social_media && (this.props.feedback.business.social_media.iwanttoplay == 1) &&
                                        <button className="dropdown-item" data-text={this.props.feedback.business.social_media && this.props.feedback.business.social_media.iwanttoplay == 1 ? "https://ratethisbiz.com/" + this.props.feedback.short_id : null} onClick={this.handleReviewOnly.bind(this)} type="button">{__('Paste Review Link')}</button>
                                    }
                                </div>

                            </div>
                        }

                        {/* <div className="dropdown emoji-dropdown">
                            <button className="btn btn-outline-secondary mr-2 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Emojis
                            </button>
                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                            <div className="dropdown-item bg-white"><emoji-picker></emoji-picker></div>
                            </div>
                        </div> */}

                        <div className="dropdown">
                            <button className="btn btn-outline-secondary mr-2 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {__('Send Pre-canned Response')}
                            </button>
                            {this.props.feedback.business.precanned &&
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    {this.props.feedback.business.precanned.map((value, index) => {
                                        return <a className="dropdown-item text-capitalize" key={index} onClick={this.handlePreCanned.bind(this)} data-text={value.text} href="#">{value.label}</a>
                                    })}
                                </div>
                            }
                        </div>

                        <button className={this.props.loading ? "disabled btn btn-primary" : "btn btn-primary"} onClick={this.handleClick.bind(this)} type="button"><i className="fas fa-paper-plane mr-1"></i> {__('Send')}</button>
                    </div>

                    <div className="col-sm-12 text-right d-block d-sm-none">
                        {this.props.feedback.business.social_media && (this.props.feedback.business.social_media.iwanttoplay == 1) &&
                            <div className="dropdown mb-2">
                                <button className="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {__('Insert Rating Request')}
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <button className="dropdown-item" data-text={this.props.feedback.business.social_media && this.props.feedback.business.social_media.iwanttoplay == 1 ? this.props.feedback.business.social_media.description + " https://ratethisbiz.com/" + this.props.feedback.short_id : null} onClick={this.handleReview.bind(this)} type="button">{__('Send Review Request - Issue')}</button>
                                    <button className="dropdown-item" data-text={this.props.feedback.business.social_media && this.props.feedback.business.social_media.iwanttoplay == 1 ? this.props.feedback.business.social_media.description_positive + " https://ratethisbiz.com/" + this.props.feedback.short_id : null} onClick={this.handleReview.bind(this)} type="button">{__('Send Review Request - Happy')}</button>
                                    <button className="dropdown-item" data-text={this.props.feedback.business.social_media && this.props.feedback.business.social_media.iwanttoplay == 1 ? "https://ratethisbiz.com/" + this.props.feedback.short_id : null} onClick={this.handleReviewOnly.bind(this)} type="button">{__('Paste Review Link')}</button>
                                </div>
                            </div>
                        }

                        <div className="dropdown">
                            <button className="btn btn-outline-secondary mr-sm-2 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {__('Send Pre-canned Response')}
                            </button>
                            {this.props.feedback.business.precanned &&
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    {this.props.feedback.business.precanned.map((value, index) => {
                                        return <a className="dropdown-item text-capitalize" key={index} onClick={this.handlePreCanned.bind(this)} data-text={value.text} href="#">{value.label}</a>
                                    })}
                                </div>
                            }
                        </div>

                        <button className={this.props.loading ? "disabled btn btn-primary mt-1" : "btn btn-primary mt-1"} onClick={this.handleClickMobile.bind(this)} type="button"><i className="fas fa-paper-plane mr-1"></i> {__('Send')}</button>
                    </div>
                </div>

            </div>

        );
    }

}

function mapStateToProps(state) {
    return { feedback: state.feedback_detail, loading: state.loading, feedback_id: state.selected_feedback }
}

export default connect(mapStateToProps)(MessengerSection);
